import { Ancizar_Serif, Inter } from "next/font/google";

const inter = Inter({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700", "800"],
  variable: "--font-inter",
  display: "swap",
});

const ancizarSerif = Ancizar_Serif({
  subsets: ["latin"],
  weight: ["500", "600"],
  variable: "--font-ancizar-serif",
  display: "swap",
  adjustFontFallback: false,
});

export const fontVariablesClassName = `${inter.variable} ${ancizarSerif.variable}`;
